/**
 * FaqAccordion - natywny <details>/<summary> akordeon dla sekcji FAQ na blogu.
 *
 * Dlaczego natywny <details>: tresc zostaje w DOM (crawlable przez Google/LLM
 * nawet gdy zwinieta), zero JS, dostepny z klawiatury out-of-box. Para z
 * FAQPage JSON-LD schema w BlogPostPage daje max widocznosc w AI Overviews.
 */

export interface FaqItem {
  q: string;
  a: string;
}

export default function FaqAccordion({ items }: { items: FaqItem[] }) {
  if (!items?.length) return null;
  return (
    <div className="not-prose my-8 space-y-3">
      {items.map((item, i) => (
        <details
          key={i}
          open={i === 0}
          className="group rounded-2xl border border-stroke bg-surface/40 px-5 py-4 transition-colors hover:bg-surface/70"
        >
          <summary className="flex cursor-pointer items-center justify-between gap-4 text-base font-medium text-text-primary list-none [&::-webkit-details-marker]:hidden">
            {item.q}
            <span className="shrink-0 text-accent-to transition-transform duration-200 group-open:rotate-45">
              +
            </span>
          </summary>
          <p className="mt-3 text-muted leading-relaxed">{item.a}</p>
        </details>
      ))}
    </div>
  );
}
